// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-6c1daf7b]{height:50px;background:#fff;box-shadow:0 0 23px 1px rgba(0,0,0,.08);padding:13px 50px;position:fixed;z-index:1;top:0}.header .header-container .header-logo[data-v-6c1daf7b]:hover{cursor:pointer}.header .header-container .header-logo[data-v-6c1daf7b]{width:auto}", ""]);
// Exports
module.exports = exports;
